import LazyLoad from 'vanilla-lazyload';

// Load images
window.lazyLoadInstance = new LazyLoad({});

// Load videos
document.addEventListener('DOMContentLoaded', function () {
    const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy-custom'));

    if ('IntersectionObserver' in window) {
        const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    for (const source in video.target.children) {
                        const videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    video.target.play(); // Force play video
                    video.target.classList.add('loaded');
                    video.target.classList.remove('lazy-custom');
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }
});
